import { MaxUint48, MaxUint160, MaxUint256 } from '../../../constants.js';
export const MaxAllowanceTransferAmount = MaxUint160;
export const MaxAllowanceExpiration = MaxUint48;
export const MaxOrderedNonce = MaxUint48;
export const MaxSignatureTransferAmount = MaxUint256;
export const MaxUnorderedNonce = MaxUint256;
export const MaxSigDeadline = MaxUint256;
export const InstantExpiration = 0n;
//# sourceMappingURL=constants.js.map